import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastmessageService } from 'src/app/toastmessage.service';
import { MessService } from '../mess.service';

export interface MessHolidayClosePayload {
  buildingId: string | number;
  inventoryDate: string;
  studentCount: number;
  employeeCount: number;
  subStaffCount: number;
  visitorsCount: number;
  status: string;
  daysheetAmount: number;
  scenarioBasedMenuItemsList: unknown[];
  supplyBuildings: unknown[];
}

export interface HolidayCloseDialogData {
  daysheetDate: string;
  holidayReason: string;
  closePayload: MessHolidayClosePayload;
}

@Component({
  selector: 'app-holiday-close-dialog',
  templateUrl: './holiday-close-dialog.component.html',
  styleUrls: ['./holiday-close-dialog.component.scss'],
})
export class HolidayCloseDialogComponent {
  daysheetDate: string;
  holidayReason: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: HolidayCloseDialogData,
    private readonly dialogRef: MatDialogRef<HolidayCloseDialogComponent>,
    private readonly service: MessService,
    private readonly spinner: NgxSpinnerService,
    private readonly toast: ToastmessageService,
    private readonly router: Router,
  ) {
    this.daysheetDate = String(data?.daysheetDate ?? '').trim();
    this.holidayReason = String(data?.holidayReason ?? '').trim() || '—';
  }

  closeHoliday(): void {
    this.dialogRef.close(false);
  }

  daysheetCloseHoliday(): void {
    const payload = this.data?.closePayload;
    if (!payload?.buildingId || !payload?.inventoryDate) {
      this.toast.showError('Missing building or date for daysheet close.');
      return;
    }
    this.spinner.show();
    this.service.postMessInventory(payload).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        this.toast.showSuccess(res.message);
        this.dialogRef.close(true);
        this.router.navigate(['/messDoDetails']);
        this.spinner.hide();
      },
      error: (err: any) => {
        this.toast.showError(err?.error?.message ?? 'Failed to close daysheet.');
        this.spinner.hide();
      },
    });
  }
}
